import Icon from '../components/Icon.vue'

Icon.register({
  'street-view': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M367.9 329.8C363.3 335.1 358.1 339.9 352 343.4V366.4C418.5 375.7 464 394.4 464 416 464 446.9 370.9 472 256 472S48 446.9 48 416C48 394.4 93.5 375.7 160 366.4V343.4C153.9 339.9 148.7 335.1 144.1 329.8 58.9 345.3 0 378.1 0 416 0 469 114.6 512 256 512S512 469 512 416C512 378.1 453.1 345.3 367.9 329.8zM256 128C291.4 128 320 99.4 320 64S291.4 0 256 0 192 28.6 192 64 220.7 128 256 128zM192 320V416C192 433.7 206.3 448 224 448H288C305.7 448 320 433.7 320 416V320C337.7 320 352 305.7 352 288V192C352 165.5 330.5 144 304 144H292.2C281.1 149 268.9 152 256 152S230.9 149 219.8 144H208C181.5 144 160 165.5 160 192V288C160 305.7 174.3 320 192 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/street-view.js
// module id = X6nE
// module chunks = 144